(() => {
    window.addEventListener("ucEvent", function (e) {
        if( e.detail && e.detail.event == "consent_status") {
            if (e.detail["YouTube Video"]) {
                document.querySelectorAll('.yt-consent-overlay').forEach(
                    (overlay) => overlay.remove()
                )

                document.querySelectorAll('iframe[data-usercentrics="YouTube Video"]').forEach(
                    (iframe) => {
                        iframe.setAttribute('src', iframe.getAttribute('data-src'))
                    }
                )
            }

            if (e.detail["Typeform"]) {
                document.querySelectorAll('.typeform-consent-overlay').forEach(
                    (overlay) => overlay.remove()
                )
            }
        }
    });
}) ()
